// import VueI18n from "vue-i18n";
// const i18n = new VueI18n({
//   locale: localStorage.getItem('locale') || "zh",
//   messages: {
//     "en": require("../lang/en"),
//     "zh": require("../lang/zh"),
//   },
// });
import "../main"

var processApi = process.env.NODE_ENV == 'development' ? '/api/v1/FileController/upload' : '/v1/FileController/upload'
var processFile = process.env.NODE_ENV == 'development' ? '/api/v1/getExportExcel/exportTerminalId' : '/v1/getExportExcel/exportTerminalId'
var domainName = process.env.NODE_ENV == 'development' ? 'iot.zeji.com:9601' : 'iot.zeji.com:9601'

var findID = function (tree, name, backObj) {
  tree && tree.filter((father) => {
    if (father.path == name) {
      father['navShow'] = true
    } else {
      let Arr = JSON.parse(JSON.stringify(name)).split('/');
      let ArrOne = Arr[1] == undefined ? "" : '/' + Arr[1]
      let ArrTwo = Arr[2] == undefined ? "" : ArrOne + "/" + Arr[2]
      let ArrThree = Arr[3] == undefined ? "" : ArrTwo + '/' + Arr[3]
      if (father.path == ArrOne || father.path == ArrTwo || father.path == ArrThree) {
        father['navShow'] = true
      }
      if (father.children) {
        findID(father.children, name)
      }
    }
  })
}
var emailRule = (rule, value, callback) => {
  var strRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  if (!strRegex.test(value)) {
    callback(new Error(i18n.t('common.form.email')));
  } else {
    callback();
  }
};
var sortRule = (rule, value, callback) => {
  var strRegex = /^[0-9,]*$/;
  if (!strRegex.test(value)) {
    callback(new Error(i18n.t('common.form.sort')));
  } else {
    callback();
  }
};

var cycleRule = (rule, value, callback) => {
  if (value < 30) {
    callback(new Error('输入天数要大于等于30'));
  } else {
    callback();
  }
};

var timer;
const debounce = (fn, interval) => {
  var gapTime = interval || 500;
  if (timer) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn()
    }, gapTime);
  } else {
    timer = setTimeout(() => {
      fn()
    }, gapTime);
  }
}

const buttonPremiss = (key) => {
  let isHidden = false
  let buttonList = JSON.parse(sessionStorage.getItem('buttonPermiss'))
  buttonList && buttonList.map((item, index) => {
    if (item.name == key) {
      isHidden = true
    }
  })
  return isHidden
}

export {
  processApi, domainName, processFile, emailRule, cycleRule, findID, sortRule, debounce, buttonPremiss
};